import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {buyersApi} from '../api';
import {assertBuyersReturned, invalidateBuyerCaches} from '../utils';

import type {AddBuyersToPurchasePayload} from '@sollapay/types';

export function useAddBuyersToPurchaseMutation(trustAccountId: string, purchaseId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AddBuyersToPurchasePayload) => {
      const response = await buyersApi.addBuyersToPurchase(
        client,
        trustAccountId,
        purchaseId,
        payload
      );
      assertBuyersReturned(response.data);
      return response;
    },
    // On failure too — a failed request may still have changed the roster server-side.
    onSettled: response => {
      invalidateBuyerCaches(
        queryClient,
        trustAccountId,
        response?.data.map(buyer => buyer.id) ?? []
      );
    }
  });
}
